'use strict';

angular.module('selfAccessRequestControllers')

.controller('ArrivalPreAuthorizedDeltaSystemTypeListController',
            ['$scope', '$state', '$stateParams', 'selfAccessRequestService', 'decisionSystemTypesList',
    function ($scope, $state, $stateParams, selfAccessRequestService, decisionSystemTypesList) {

        // Return if we are not in the right state
        if (!$state.is('selfAccessRequest.arrival.preAuthorizedDelta')) return;

        // If no decisions inside the list return
        if (_.size(decisionSystemTypesList) === 0) return;

        // Go to State selected
        $state.go('selfAccessRequest.arrival.preAuthorizedDeltaBySystemType', {
            systemTypeSlug: decisionSystemTypesList[0].Slug,
            employeeID: $stateParams.employeeID
        });

}]);